import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { StepsState } from '../order-report.component';
import { ReportTypes, SubscriptionPlans } from '../../../user/user/user.model';
import { ReportsService } from '../../reports.service';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { CustomRadioGroupComponent } from 'src/app/shared/components/custom-radio-group/custom-radio-group.component';
import { GoogleAnalyticsService } from '../../../user/google-analytics.service';
import { BreakpointObserverService } from '../../../shared/services/breakpoint-observer.service';
import { UserAccessService } from '../../../user/access/user-access.service';
import { EqualizeCardsHeightDirective } from '../../../shared/directives/equalize-cards-height.directive';
import { TypeCardComponent } from '../../../shared/components/type-card/type-card.component';
import { reportData } from './report-type/reports-info';

export const activeReportTypesToTitle: Map<ReportTypes, string> = new Map([
  [ReportTypes.COMMUNITY_COMPASS, 'Community Compass'],
  [ReportTypes.OPEN_HOUSE_FLYER, 'Open house flyer'],
  [ReportTypes.LOCATION_INTELLIGENCE, 'Location Intelligence'],
  [ReportTypes.FEASIBILITY_STUDY, 'Feasibility Study'],
  [ReportTypes.COMPARATIVE_LOCATION, 'Comparative Location Analysis'],
  // [ReportTypes.MAP_AI_LOCATION_OVERVIEW_FOR_BEAUTY_SALONS, 'Map AI Location overview for beauty salons']
]);

@Component({
  selector: 'app-choose-type',
  templateUrl: './choose-type.component.html',
  styleUrls: [
    './choose-type.component.scss',
    '../../reports.component.scss',
    '../../../app.component.scss',
  ],
  imports: [
    CustomRadioGroupComponent,
    NgFor,
    NgIf,
    AsyncPipe,
    EqualizeCardsHeightDirective,
    TypeCardComponent,
  ],
})
export class ChooseTypeComponent implements OnInit {
  @ViewChild(EqualizeCardsHeightDirective)
  equalizer!: EqualizeCardsHeightDirective;

  @Output() nextStep = new EventEmitter<string>();

  @Input() currentStepData!: StepsState['chooseType'];

  public isSelectedReportReadyToOrder: boolean = false;
  public selectedCheckbox: ReportTypes | null =
    this.reportsService.lastSelectedReportType;

  // List of reports that are already implemented on backend
  public readyToOrdersReports = [
    ReportTypes.COMMUNITY_COMPASS,
    ReportTypes.FEASIBILITY_STUDY,
  ];

  get availableReportsCount(): number {
    return this.accessService.getIsAdmin() ||
      this.accessService.getUserPlan() === SubscriptionPlans.FULL_ACCESS
      ? reportData.length
      : reportData.filter((r) => !r.forInnerUse).length;
  }

  get isWideScreen(): boolean {
    return window.innerWidth > 1200;
  }

  get gridCols(): string | null {
    return this.isWideScreen
      ? `repeat(${this.availableReportsCount}, 1fr)`
      : `repeat(2, 1fr)`;
  }

  constructor(
    public accessService: UserAccessService,
    private reportsService: ReportsService,
    private gaService: GoogleAnalyticsService,
    private breakpointObserver: BreakpointObserverService
  ) {}

  ngOnInit(): void {
    this.isSelectedReportReadyToOrder = this.readyToOrdersReports.includes(
      this.selectedCheckbox!
    );
  }

  public onFeatureExtended(): void {
    requestAnimationFrame(() => this.equalizer.equalize());
  }

  private equalizeFeaturesList(nodes: HTMLElement[]): void {
    const anyExtended = nodes.some((n) => n.classList.contains('extended'));
    const size = anyExtended ? '262px' : '70px';
    nodes.forEach((n) => (n.style.height = size));
  }

  private equalize(nodes: HTMLElement[]): void {
    // Find max height, apply it's value to other elements of a kidn
    let max = Math.max(...nodes.map((n) => n.getBoundingClientRect().height));
    nodes.forEach((n) => (n.style.height = `${max}px`));
  }

  public handleActiveSelectionChange(activeSelection: ReportTypes): void {
    if (Object.values(ReportTypes).includes(activeSelection as ReportTypes)) {
      this.isSelectedReportReadyToOrder =
        this.readyToOrdersReports.includes(activeSelection);
      this.selectedCheckbox = activeSelection;
    }
  }

  public handleNextStep(): void {
    if (this.isSelectedReportReadyToOrder) {
      this.reportsService.setSelectedReportType(this.selectedCheckbox!);
      this.nextStep.emit();
      this.gaService.logReportOrderTypeConfirmed();
    } else {
      window.location.href = 'mailto:info@map-ai.co';
    }
  }

  protected readonly SubscriptionPlans = SubscriptionPlans;
  protected readonly reportData = reportData;
}
